import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IGroup, IGroupContainer, IItem, ISection, getFormDirtyValues } from '../../models/group-edit-config';
import { FormControl } from '@angular/forms';
import { DialogService } from '../../services/dialog.service';
import { DialogBoxResults } from '../../models/dialogDefaults';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalEditorComponent } from '../modal-editor/modal-editor.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-group-edit-container',
  templateUrl: './group-edit-container.component.html',
  styleUrls: ['./group-edit-container.component.scss']
})
export class GroupEditContainerComponent implements OnInit, OnDestroy {
    @Input('config') config: IGroupContainer;
    @Input('dialogRef') dialogRef: MatDialogRef<ModalEditorComponent>;

    selectedGroup: IGroup;
    selectedSection: ISection;
    sub = new Subject();
    description: any;

    @Output('groupChanged') groupChanged = new EventEmitter<IGroup>();
    @Output('sectionEditing') sectionEditing = new EventEmitter<ISection>();

    constructor(private dlg: DialogService,
        private router: Router,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        if(this.config.urlEnabled){
            this.route.params.pipe(takeUntil(this.sub))
                .subscribe(p => {
                    const group = p['group'];
                    if(group){
                        const findGroup = this.config.groups.find(x=>x.url === group);
                        this.selectGroupInternal(findGroup);
                    }else{
                        const findGroup = this.config.groups[0];
                        this.router.navigate([ this.config.urlBase, findGroup.url]);
                    }
                });
        }else{
            this.selectGroupInternal(this.config.groups[0]);
        }

        if(this.config.description){
            this.description = this.sanitizer.bypassSecurityTrustHtml(this.config.description);
        }
        
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    //Called by UI to activate the new group
    selectGroup(g: IGroup){
        if(this.config.urlEnabled){
            this.router.navigate([this.config.urlBase, g.url]);
        }else{
            this.selectGroupInternal(g);
        }
    }

    //Used internally to actually activate a group identified by routing or selection
    selectGroupInternal(g: IGroup){
        this.selectedGroup = g;
        this.groupChanged.emit(g);
    }

    editSection(s: ISection){
        if(this.selectedSection === s){
            this.selectedSection = null;
        }else{
            this.selectedSection = s;    
        }
    }

    async completedModalAction(){
        this.config.completeAction(this.dialogRef);
    }

    async cancelledModalEdit(){
        const data = {};
        getFormDirtyValues(this.config.form, data);
        if(Object.keys(data).length > 0) {
            const dbsRes = await this.dlg.showYesNo("Close editor without saving", "You have unsaved changes in the editor window.  Are you sure you want to close without saving?");
            if(dbsRes === DialogBoxResults.Yes){
                this.config.cancelAction(this.dialogRef);
            }
        }else{
            this.config.cancelAction(this.dialogRef);
        }        
    }

    // async saveSection(s: ISection){
    //     if(s.completedAction){
    //         const res = await s.completedAction();
    //         if(res){
    //             this.editSection(null);
    //         }
    //     }else{
    //         this.editSection(null);
    //     }
    // }
    
    // cancelledSection(){
    //     this.editSection(null);
    // }
}
